import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FieldExpression, phrase, toString as luceneToString } from 'lucene';

import { AQDB_SERVER_URL } from '../../config';
import { PaginatedResult } from '../../shared/models/paginated-result';
import { FieldOfTrackingBatch, TrackingBatch } from '../models/tracking-batch';

@Injectable({ providedIn: 'root' })
export class AqdbService {
	constructor(
		private readonly http: HttpClient
	) {}

	getTrackingBatches(barcode: string, fields: readonly FieldOfTrackingBatch[]) {
		const url = new URL(`${ AQDB_SERVER_URL }/v1/trackingBatches`);
		const params = url.searchParams;
		params.append('fields', fields.join(','));
		const supplierOrderItemField: FieldExpression = {
			field: 'positions.id',
			term: phrase.escape(barcode),
			quoted: true
		};
		params.append('filter', luceneToString(supplierOrderItemField));

		return this.http.get<PaginatedResult<TrackingBatch>>(url.toString());
	}
}
